import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

interface SearchStorage {
  [key: string]: {
    [key: string]: string | number | boolean;
  }
}

interface SearchStorageItem {
  [key: string]: string | number | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SearchStorageService {
  private storage: SearchStorage = {};
  private readonly router = inject(Router);
  private previousUrl?: string;
  private currentUrl?: string;

  constructor() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url) {
        this.currentUrl = this.extractRouteSegment(event.url);

        const shouldForceReset = history.state?.resetSearchStorage === true;

        if (this.currentUrl !== this.previousUrl || shouldForceReset) {
          this.reset();
          this.previousUrl = this.currentUrl;
        }
      }
    });
  }

  public set(params: SearchStorageItem): void {
    if (this.currentUrl === undefined) return;

    if (params) {
      this.storage[this.currentUrl] = params;
    } else {
      this.reset();
    }
  }

  public get(): SearchStorageItem | undefined {
    if (this.currentUrl === undefined) return;
    return this.storage[this.currentUrl] ?? undefined;
  }

  public reset(): void {
    if (this.currentUrl === undefined) return;
    delete this.storage[this.currentUrl];
  }

  private extractRouteSegment(url: string): string {
    const segments = url.split('/').find(segment => segment.length > 0);
    return segments || '';
  }
}
